export default {
      id: "icon-doc-usage",
      viewBox: "0 0 112 112",
      url: "/" + "assets/sprite.svg#icon-doc",
      toString: function () {
        return this.url;
      }
    }